import React from 'react';

import { Provider as AuthProvider } from './AuthContext';

export default function ContextProvider({ children }) {return <AuthProvider>{children}</AuthProvider>};
